import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const personRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.persons,
    name: routeNames.persons,
    component: () => import('@/pages/persons/PersonsView.vue'),
    meta: {
      permission: 'persons.read.all',
      icon: 'material-symbols-outlined',
      iconText: 'group',
      labelKey: 'persons',
    },
  },
  {
    path: routePaths.personDetails,
    name: routeNames.personDetails,
    component: () => import('@/pages/persons/details/PersonDetailsView.vue'),
    meta: {
      permission: 'persons.read.all',
      rootRouteName: routeNames.persons,
    },
  },
  {
    path: routePaths.personMerge,
    name: routeNames.personMerge,
    component: () => import('@/pages/persons/details/PersonMergeDuplicate.vue'),
    meta: {
      permission: 'persons.write.all',
      rootRouteName: routeNames.persons,
      labelKey: 'duplicateMerge',
    },
  },
  {
    path: routePaths.personCreation,
    name: routeNames.personCreation,
    component: () => import('@/pages/persons/creation/AddEditPersonView.vue'),
    meta: {
      permission: 'persons.write.all',
      rootRouteName: routeNames.persons,
      labelKey: 'new_f',
    },
  },
  {
    path: routePaths.personEdit,
    name: routeNames.personEdit,
    component: () => import('@/pages/persons/creation/AddEditPersonView.vue'),
    meta: {
      permission: 'persons.write.all',
      rootRouteName: routeNames.persons,
      labelKey: 'edit',
    },
  },
  {
    path: routePaths.personLinks,
    name: routeNames.personLinks,
    redirect: { name: routeNames.personDetails },
    meta: {
      permission: 'persons.read.all',
      labelKey: 'personLinks',
      rootRouteName: routeNames.persons,
    },
  },
  {
    path: routePaths.personLinkCreation,
    name: routeNames.personLinkCreation,
    component: () => import('@/pages/persons/creation/AddPersonLinkView.vue'),
    meta: {
      permission: 'persons.write.all',
      rootRouteName: routeNames.persons,
      labelKey: 'new_m',
    },
  },
]
